import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { fr } from 'vuetify/locale'
import { App, getRouter, vuetifyOptions, type IConfiguration, type IProfileTab } from '@fondationcss/ui';
import { getCustomRoutes } from './routes';
import { menus } from './sidebar-items';
import { WikiPlugin } from '@fondationcss/wiki'
import VueApexCharts from 'vue3-apexcharts';
import PageHeader from '@/components/page-header.vue';
import ProfileActions from '@/components/profile-actions.vue';

import 'vuetify/styles';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fondationcss/ui/dist/style.css';
import '@fondationcss/wiki/dist/style.css';
import '@fondationcss/markdown/dist/style.css';
import '@fondationcss/markdown/dist/markdown.css';
import "@/styles.css";
import "@/styles/tables.css";
import 'highlight.js/styles/github.css';

const config = {
  AppName: 'Parcours',
  SiteNameShort: 'Parcours',
  SiteNameLong: 'Byrnu Parcours',
  LogoLine1: 'Byrnu',
  LogoLine2: 'Parcours',
  Copyright: 'Copyright © 2026',
  MenuGroupsOrientation: 'vertical',
  Menus: menus,
  EnableAccessRequestButton: false,

  DefaultLayout: 'byrnu-red-app',
  ThemeColor: '#3460a8',
  Logo: '/images/parcours.svg',  // Generic logo fallback (URL)
  SiteLogo: '/images/parcours.svg',  // Logo for login/init screens (URL)
  // SiteLogoSvg: '<svg>...</svg>'  // Logo for login/init screens (raw SVG - takes priority over SiteLogo and Logo)
  SiteLogoAlt: '/images/parcours-alt.svg',  // Logo for header (URL)
  // SiteLogoAltSvg: '<svg>...</svg>'  // Logo for header (raw SVG - takes priority over all others)
  HideLoginLogo: true,
} as IConfiguration;

const vuetify = createVuetify({
  components,
  directives,
  ...vuetifyOptions,
  locale: {
    locale: "fr",
    messages: { fr }
  }
})
const app = createApp(App);
const router = getRouter(getCustomRoutes);
app.provide('config', config)
app.provide('sdkOptions', { apiUrl: import.meta.env.VITE_API_URL ?? undefined })
app.provide('profileTabs', [
  {
    value: 'parcours-actions',
    icon: 'fas fa-bolt',
    label: 'Actions',
    component: ProfileActions,
    insertLocation: '222', // insert before Paramètres
  },
] satisfies IProfileTab[])
app.use(vuetify);
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('PageHeader', PageHeader)
library.add(fas)
library.add(far)
app.use(createPinia());
app.use(PerfectScrollbarPlugin);
app.use(router);
 
app.use(VueApexCharts);
// Type assertion needed due to Vue 3.5+ stricter Plugin generic constraints
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(WikiPlugin as any, { router })
app.mount('#app');
